import { RequestWebApi, validateRequestErrorStatus } from "./Requests";

const controller = "MetaWhatsAppTemplate";

const parseApiError = (error, defaultMessage) => {
  validateRequestErrorStatus(error?.response?.status);

  const data = error?.response?.data || {};
  const message = data?.message || defaultMessage;
  const errors = data?.errors || [];

  return { message, errors };
};

// GET /api/v1/MetaWhatsAppTemplate/Templates
export const ListarMetaWhatsAppTemplates = () =>
  RequestWebApi.get(`/${controller}/Templates`)
    .then((response) => {
      const { success, resultData, message, errors } = response.data || {};

      return {
        success: !!success,
        templates: resultData ?? [], // lista de MetaWhatsAppTemplateOperacaoDto
        message: message ?? "",
        errors: errors ?? []
      };
    })
    .catch((error) => {
      const { message, errors } = parseApiError(error, "Erro ao listar templates do WhatsApp.");

      return {
        success: false,
        message,
        errors,
        templates: []
      };
    });

// POST /api/v1/MetaWhatsAppTemplate/Incluir
// body: { data: MetaWhatsAppTemplateOperacaoDto }
export const IncluirMetaWhatsAppTemplate = (data) => {
  if (!data) {
    return Promise.resolve({
      success: false,
      message: "Dados do template não informados.",
      errors: [],
      templateId: 0
    });
  }

  if (!data.metaWhatsAppTemplateCodigo || !data.metaWhatsAppTemplateCodigo.trim()) {
    return Promise.resolve({
      success: false,
      message: "Código do template não informado.",
      errors: [],
      templateId: 0
    });
  }

  return RequestWebApi.post(`/${controller}/Incluir`, { data })
    .then((response) => {
      const { success, resultData, message, errors } = response.data || {};

      return {
        success: !!success,
        templateId: resultData ?? 0,
        message: message ?? "",
        errors: errors ?? []
      };
    })
    .catch((error) => {
      const { message, errors } = parseApiError(error, "Erro ao incluir template do WhatsApp.");

      return {
        success: false,
        message,
        errors,
        templateId: 0
      };
    });
};

// PUT /api/v1/MetaWhatsAppTemplate/Atualizar
// body: { data: MetaWhatsAppTemplateOperacaoDto }
export const AtualizarMetaWhatsAppTemplate = (data) => {
  if (!data) {
    return Promise.resolve({
      success: false,
      message: "Dados do template não informados.",
      errors: []
    });
  }

  if (!data.metaWhatsAppTemplateId || data.metaWhatsAppTemplateId <= 0) {
    return Promise.resolve({
      success: false,
      message: "Id do template não informado.",
      errors: []
    });
  }

  if (!data.metaWhatsAppTemplateCodigo || !data.metaWhatsAppTemplateCodigo.trim()) {
    return Promise.resolve({
      success: false,
      message: "Código do template não informado.",
      errors: []
    });
  }

  return RequestWebApi.put(`/${controller}/Atualizar`, { data })
    .then((response) => {
      const { success, resultData, message, errors } = response.data || {};

      return {
        success: !!success,
        ok: resultData ?? false,
        message: message ?? "",
        errors: errors ?? []
      };
    })
    .catch((error) => {
      const { message, errors } = parseApiError(error, "Erro ao atualizar template do WhatsApp.");

      return {
        success: false,
        message,
        errors,
        ok: false
      };
    });
};

// DELETE /api/v1/MetaWhatsAppTemplate/Remover/{id}
export const RemoverMetaWhatsAppTemplate = (metaWhatsAppTemplateId) => {
  if (!metaWhatsAppTemplateId || metaWhatsAppTemplateId <= 0) {
    return Promise.resolve({
      success: false,
      message: "Id do template não informado.",
      errors: [],
      ok: false
    });
  }

  return RequestWebApi.delete(`/${controller}/Remover/${metaWhatsAppTemplateId}`)
    .then((response) => {
      const { success, resultData, message, errors } = response.data || {};

      return {
        success: !!success,
        ok: resultData ?? false,
        message: message ?? "",
        errors: errors ?? []
      };
    })
    .catch((error) => {
      const { message, errors } = parseApiError(error, "Erro ao remover template do WhatsApp.");

      return {
        success: false,
        message,
        errors,
        ok: false
      };
    });
};
